import { VpSkeleton } from '@vtmn-play/react'

export const QuestionSkeleton = () => (
  <div className="px-4">
    <div className="flex mt-5 items-center justify-between w-full mb-5">
      <VpSkeleton className="ml-2" style={{ height: '30px', width: '30px' }} />
      <VpSkeleton style={{ height: '30px', width: '210px' }} />
    </div>

    <div className="flex mt-5 items-center justify-between w-full mb-5">
      <VpSkeleton className="ml-2" style={{ height: '30px', width: '210px' }} />
      <VpSkeleton style={{ height: '30px', width: '70px' }} />
    </div>

    <VpSkeleton shape="rounded" style={{ marginBottom: 50, height: '120px' }} />
    <VpSkeleton shape="rounded" style={{ marginBottom: 30, height: '250px' }} />

    <VpSkeleton shape="rounded" style={{ marginBottom: 10, height: '50px' }} />
    <VpSkeleton shape="rounded" style={{ marginBottom: 10, height: '50px' }} />
    <VpSkeleton shape="rounded" style={{ marginBottom: 10, height: '50px' }} />

    <div className="flex items-center justify-between w-full p-5 fixed bottom-0 left-0 bg-white">
      <VpSkeleton style={{ marginBottom: 8, height: '50px', width: '100px' }} />
      <VpSkeleton style={{ height: '50px', width: '100px' }} />
    </div>
  </div>
)
